import { render, staticRenderFns } from "./PassModal.vue?vue&type=template&id=c54c126e"
import script from "./PassModal.vue?vue&type=script&lang=js"
export * from "./PassModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports